import { defineComponent as _defineComponent } from 'vue'
import { PaymentReport, FeeChargeType, PaymentState, ExportListType, routingCodeTypeLabels } from 'ah-api-gateways';
import { formatDate } from 'ah-common-lib/src/helpers/time';
import { computed } from 'vue';
import PaymentsTradeDetailsModal from 'ah-payments/src/components/modals/PaymentsTradeDetailsModal.vue';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useNotificationsStore } from 'ah-notifications/src/store';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import PaymentsCancelModal from 'ah-payments/src/components/modals/PaymentsCancelModal.vue';
import PaymentsCreateEditModal from 'ah-payments/src/components/modals/PaymentsCreateEditModal.vue';
import { usePaymentState } from 'ah-payments';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentDetails',
  props: {
    payment: null
  },
  emits: ["update-payment", "cancel-payment"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update-payment'): void;
  (e: 'cancel-payment'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  payment: PaymentReport;
};

const paymentState = usePaymentState();

const requestManager = useRequestManager().manager;





const cutoffTime = computed(() => {
  if (!props.payment.cutoffTime) {
    return '-';
  }
  let date = new Date();
  let time = props.payment.cutoffTime;
  const dateTime = new Date(formatDate(date, 'yyyy-MM-dd') + ' ' + time);
  return formatDate(dateTime, 'HH:mm');
});

const paymentFee = computed(() => {
  if (props.payment.clientId === null) {
    return `${props.payment.partnerFeeCurrency}  ${formatCurrencyValue(props.payment.partnerFeeAmount)}`;
  }
  return `${props.payment.clientFeeCurrency}  ${formatCurrencyValue(props.payment.clientFeeAmount)}`;
});

const paymentCanEditOrCancel = computed(() => {
  return (
    props.payment.state === PaymentState.QUEUED ||
    props.payment.state === PaymentState.PENDING ||
    props.payment.state === PaymentState.SCHEDULED
  );
});

function downloadPayment() {
  requestManager
    .cancelAndNew('downloadPayment', paymentState.services.payments.downloadPayment(props.payment.id))
    .subscribe((doc) => useNotificationsStore().triggerFileExportRequestNotification(doc));
}

function downloadPaymentMt103() {
  requestManager
    .cancelAndNew(
      'downloadPaymentMt103',
      paymentState.services.payments.downloadPaymentMt103(props.payment.id, 'PDF' as ExportListType)
    )
    .subscribe((doc) => useNotificationsStore().triggerFileExportRequestNotification(doc));
}

const feeTypeTooltip = (state: FeeChargeType) => {
  switch (state) {
    case FeeChargeType.SHA:
      return 'The intermediary bank charges are deducted from the payment amount. As a result, the beneficiary may receive less than the full payment amount.';
    case FeeChargeType.ACO:
      return 'The intermediary bank charges are covered by the payer and not deducted from the payment amount.';
    default:
      return '';
  }
};

function onPaymentSaved() {
  emit('update-payment');
}

return { __sfc: true,paymentState, requestManager, props, emit, cutoffTime, paymentFee, paymentCanEditOrCancel, downloadPayment, downloadPaymentMt103, feeTypeTooltip, onPaymentSaved, PaymentState, routingCodeTypeLabels, formatDate, PaymentsTradeDetailsModal, PaymentsCancelModal, PaymentsCreateEditModal }
}

})